import { render, staticRenderFns } from "./wxcode.vue?vue&type=template&id=2a1d0020&scoped=true&"
import script from "./wxcode.vue?vue&type=script&lang=js&"
export * from "./wxcode.vue?vue&type=script&lang=js&"
import style0 from "./wxcode.vue?vue&type=style&index=0&id=2a1d0020&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1d0020",
  null
  
)

export default component.exports